// @flow

// eslint-disable-next-line
export const DEVICE_TO_GROUP_MOVE = 'DEVICE_TO_GROUP_MOVE';
